import { ISinhVienSearchRequest } from "../../model/request/sinh-vien/ISinhVienSearchRequest";
import { apiClient, formatQueryString } from "../apiClient";

export const hoSoSinhVienApi = {
    SelectByLops: (id_lops: number[]) => apiClient.get(`ho-so-sinh-vien?${id_lops.map(id => `id_lops=${id}`).join('&')}`),
    Search: (request: ISinhVienSearchRequest) => apiClient.get(`ho-so-sinh-vien/search?${formatQueryString(request)}`),
    SelectSinhVienByLops: (id_lops: number[]) => apiClient.post(`ho-so-sinh-vien/lops`, id_lops),
    SelectSinhVienWithQuyetDinhByLops: (id_lops: number[]) => apiClient.post(`ho-so-sinh-vien/lops-with-quyet-dinh`, id_lops),
}